<div class="row">
	<div class="col-12">
		<div class="content-header">Media Object</div>
		<p class="content-sub-header mb-1">Abstract object styles for building various types of components that feature a left or right aligned image alongside textual content.</p>
	</div>
</div>

<!-- Media Object start -->
<div id="media-object">
  <section id="defaule-media">
    <div class="row match-height">
      <!--Left Aligned Media Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Left Aligned Media Objects</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Wrap your <code>&lt;img&gt;</code> tag inside of <code>.media</code> class to align your image to left. You don't have to add any extra classes to align your text to left.</p>
              <div class="media">
                <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-12.png" width="70" height="70" alt="avatar">
                <div class="media-body">
                  <h5 class="mb-1">Cookie candy</h5>
                  <p class="m-0">Lollipop cotton candy tootsie roll cheesecake carrot cake donut cookie pastry. Caramels jujubes bear claw. Croissant sugar plum icing chocolate bar halvah ice cream donut.</p>
                </div>
              </div>
              <div class="media">
                <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-11.png" width="70" height="70" alt="avatar">
                <div class="media-body">
                  <h5 class="mb-1">Tootsie roll dessert</h5>
                  <p class="m-0">Oat cake tiramisu soufflé cotton candy lemon drops gingerbread dessert gummi bears donut. Cake bonbon carrot cake chocolate cake pudding sugar plum sweet roll dragée.</p>
                </div>
              </div>
              <div class="media">
                <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-3.png" width="70" height="70" alt="avatar">
                <div class="media-body">
                  <h5 class="mb-1">Lemon drops ice cream</h5>
                  <p class="m-0">Jujubes carrot cake oat cake sugar plum fruitcake macaroon. Jelly cookie lemon drops. Soufflé cupcake macaroon ice cream lemon drops chocolate bar dessert chocolate bar.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Left Aligned Media Ends-->

      <!--Right Round Media Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Right Aligned Media With Round Images</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Use <code>.rounded-circle</code> in your <code>&lt;img&gt;</code> for round image. Use <code>.text-right</code> with <code>.media-body</code> for right aligned text.</p>
              <div class="media">
                <div class="media-body text-right mr-3">
                  <h5 class="mb-1">Oat cake </h5>
                  <p class="m-0">Chupa chups fruitcake cookie cookie candy chocolate bar sugar plum marzipan marshmallow. Muffin lollipop macaroon cookie muffin gummi bears tootsie roll gingerbread brownie.</p>
                </div>
                <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-13.png" width="70" height="70" alt="avatar">
              </div>
              <div class="media">
                <div class="media-body text-right mr-3">
                  <h5 class="mb-1">Jelly chocolate cake</h5>
                  <p class="m-0">Fruitcake danish oat cake cookie. Chupa chups toffee chocolate gingerbread chocolate bar apple pie danish liquorice. Icing cake chupa chups chocolate biscuit gummies.</p>
                </div>
                <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-6.png" width="70" height="70" alt="avatar">
              </div>
              <div class="media">
                <div class="media-body text-right mr-3">
                  <h5 class="mb-1">Pudding marshmallow</h5>
                  <p class="m-0">Halvah ice cream lemon drops gummi bears cupcake jelly-o cupcake gummies cotton candy. Bear claw donut toffee apple pie. Sweet cake carrot cake donut pastry.</p>
                </div>
                <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-18.png" width="70" height="70" alt="avatar">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Right Round Media Ends-->
    </div>
  </section>
  <!-- Media Object end -->


  <!-- Bordered Media Object start -->
  <section id="bordered-media">
    <div class="row">
      <div class="col-12">
        <div class="content-header">Bordered Media Object</div>
        <p class="content-sub-header mb-1">Wrap media list using <code>.media-bordered</code> for bordered Media Object.</p>
      </div>
    </div>
    <div class="row match-height">
      <!--Left Aligned Media Bordered Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Left Aligned Bordered Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Wrap list of media using <code>.media-bordered</code> for bordered media object.</p>
              <div class="media-bordered">
                <div class="media">
                  <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-18.png" width="70" height="70" alt="avatar">
                  <div class="media-body">
                    <h5 class="mb-1">Cookie candy</h5>
                    <p class="m-0">Tiramisu lollipop marshmallow ice cream bear claw halvah cupcake pudding apple pie. Fruitcake bonbon muffin chocolate cake donut. Soufflé cupcake bonbon jelly-o.</p>
                  </div>
                </div>
                <div class="media">
                  <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-9.png" width="70" height="70" alt="avatar">
                  <div class="media-body">
                    <h5 class="mb-1">Tootsie roll dessert </h5>
                    <p class="m-0">Cotton candy chocolate carrot cake topping pastry icing marshmallow. Chocolate jelly-o chocolate chocolate bar tootsie roll cotton candy carrot cake tootsie roll marzipan.</p>
                  </div>
                </div>
                <div class="media">
                  <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-3.png" width="70" height="70" alt="avatar">
                  <div class="media-body">
                    <h5 class="mb-1">Lemon drops ice cream</h5>
                    <p class="m-0">Cotton candy sesame snaps bear claw tootsie roll carrot cake chocolate croissant. Gummies marshmallow halvah chupa chups toffee cupcake dessert pie topping.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Left Aligned Media Bordered Ends-->

      <!--Bordered Round Media With Right Align Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Right Aligned Bordered Round Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Wrap list of media using <code>.media-bordered</code> and <code>.rounded-circle</code> for round and bordered media object.</p>
              <div class="media-bordered">
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Oat cake </h5>
                    <p class="m-0">Biscuit dessert carrot cake tootsie roll dragée apple pie lemon drops sugar plum. Candy halvah pastry gummi bears ice cream liquorice. Cotton candy cotton candy pudding.</p>
                  </div>
                  <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-7.png" width="70" height="70" alt="avatar">
                </div>
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Jelly chocolate cake</h5>
                    <p class="m-0">Soufflé halvah dessert gummi bears cotton candy. Gingerbread cake cupcake cake. Tart chupa chups biscuit chupa chups carrot cake carrot cake cookie tiramisu.</p>
                  </div>
                  <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-8.png" width="70" height="70" alt="avatar">
                </div>
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Pudding marshmallow</h5>
                    <p class="m-0">Candy carrot cake fruitcake jelly donut. Jujubes bear claw soufflé carrot cake jujubes powder apple pie pie muffin. Dragée candy canes danish wafer lollipop pudding.</p>
                  </div>
                  <img class="rounded-circle" src="assets/img/portrait/small/avatar-s-6.png" width="70" height="70" alt="avatar">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Bordered Round Media With Right Align Ends-->
    </div>
  </section>
  <!-- Bordered Media Object end -->


  <!-- Nested Media start -->
  <section id="nested-media">
    <div class="row">
      <div class="col-12">
        <div class="content-header">Nested Media Object</div>
        <p class="content-sub-header mb-1">With a bit of extra markup, you can use media inside media (useful for comment threads or articles lists). Place nested <code>.media</code> within the <code>.media-body</code> of a parent media object.</p>
      </div>
    </div>
    <div class="row match-height">
      <!--Media Aligned Left Starts-->
      <div class="col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Left Aligned Nested Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <ul class="media-bordered list-unstyled m-0">
                <li class="media">
                  <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-8.png" width="70" height="70" alt="avatar">
                  <div class="media-body">
                    <h5 class="mb-1">Parent Media</h5>
                    <p>Cupcake fruitcake icing brownie apple pie wafer chupa chups. Oat cake macaroon bear claw powder biscuit tart dragée jelly beans cake. Chocolate jujubes cupcake. Pie liquorice marshmallow candy carrot cake chupa chups.</p>
                    <div class="media pb-0">
                      <img class="rounded mr-3" src="assets/img/portrait/small/avatar-s-7.png" width="70" height="70" alt="avatar">
                      <div class="media-body">
                        <h5 class="mb-1">Nested inside Parent</h5>
                        <p class="m-0">Cupcake lemon drops carrot cake candy canes topping danish muffin muffin chocolate bar. Cotton candy dragée jelly beans carrot cake chupa chups marshmallow bear claw.</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--Media Aligned Left Ends-->

      <!--Media Aligned Right Starts-->
      <div class="col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Right Aligned Nested Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <ul class="media-bordered list-unstyled m-0">
                <li class="media">
                  <div class="media-body text-right">
                    <h5 class="mb-1">Parent Media</h5>
                    <p>Croissant chupa chups bonbon. Chocolate cake liquorice brownie lemon drops tiramisu caramels topping. Chocolate cake tart sweet roll muffin halvah icing. Bear claw halvah pie cake pie gingerbread cotton candy oat cake.</p>
                    <div class="media pb-0">
                      <div class="media-body text-right">
                        <h5 class="mb-1">Nested inside Parent</h5>
                        <p class="m-0">Oat cake macaroon halvah. Apple pie jelly pastry jujubes pie cookie. Gummies sweet roll tart jelly-o. Danish chocolate cake pastry pie tootsie roll oat cake jujubes fruitcake.</p>
                      </div>
                      <img class="ml-3 rounded-circle" src="assets/img/portrait/small/avatar-s-11.png" width="70" height="70" alt="avatar">
                    </div>
                  </div>
                  <img class="ml-3 rounded-circle" src="assets/img/portrait/small/avatar-s-18.png" width="70" height="70" alt="avatar">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--Media Aligned Right Ends-->
    </div>
  </section>
  <!-- Nested Media end -->

  <!-- Media Alignment start -->
  <section id="media-alignment">
    <div class="row">
      <div class="col-12">
        <div class="content-header">Media Alignment</div>
        <p class="content-sub-header mb-1">The images or other media can be aligned top, middle, or bottom. The default is top aligned. Now, for vertical align, Top alignment use <code>.align-self-start</code> class. For Middle alignment, use <code>.align-self-center</code> and for Bottom alignment, use <code>.align-self-end</code> with left or right aligned class.</p>
      </div>
    </div>
    <div class="row match-height">
      <!--Left Media vertical Aligned Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Left Aligned Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="media-bordered">
                <div class="media">
                  <img class="rounded align-self-start mr-3" src="assets/img/portrait/small/avatar-s-4.png" alt="avatar" width="70" height="70">
                  <div class="media-body">
                    <h5 class="mb-1">Top Aligned Media</h5>
                    <p class="m-0">Gingerbread croissant danish liquorice. Topping dessert gummi bears gummies powder dragée. Jelly carrot cake caramels topping cake jujubes ice cream caramels. Candy sweet roll icing pudding cupcake jelly beans pastry lemon drops gummi bears. Dessert caramels caramels cookie brownie danish oat cake. Bear claw cheesecake sugar plum jujubes gummi bears cake caramels icing. Biscuit sweet roll sweet carrot cake croissant jujubes danish.</p>
                  </div>
                </div>
                <div class="media">
                  <img class="rounded align-self-center mr-3" src="assets/img/portrait/small/avatar-s-12.png" alt="avatar" width="70" height="70">
                  <div class="media-body">
                    <h5 class="mb-1">Middle Aligned Media</h5>
                    <p class="m-0">Liquorice sesame snaps cookie jelly chocolate cake gummies sweet roll. Tiramisu candy canes cake. Brownie cake chupa chups jujubes tart danish gummi bears. Candy pudding sesame snaps pastry bonbon sweet. Sweet donut donut lollipop muffin. Danish lemon drops jelly beans caramels. Jujubes oat cake bonbon. Pie cupcake caramels jelly powder halvah pudding chupa chups. Cheesecake bonbon chupa chups pie icing lemon drops.</p>
                  </div>
                </div>
                <div class="media">
                  <img class="rounded align-self-end mr-3" src="assets/img/portrait/small/avatar-s-19.png" alt="avatar" width="70" height="70">
                  <div class="media-body">
                    <h5 class="mb-1">Bottom Aligned Media</h5>
                    <p class="m-0">Bear claw sweet marshmallow jelly. Topping cake powder jujubes biscuit. Cookie tootsie roll macaroon jelly beans. Cookie tiramisu chocolate cake jelly-o jelly halvah. Soufflé candy canes marshmallow. Macaroon lemon drops cheesecake candy marzipan jelly-o marshmallow soufflé. Powder dessert chocolate bar dragée jujubes sesame snaps. Gingerbread cookie cake dragée pudding liquorice. Gummi bears tiramisu chocolate cookie.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Left Media vertical Aligned Ends-->

      <!--Right Media vertical Aligned Starts-->
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Right Aligned Media</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="media-bordered">
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Top Aligned Media</h5>
                    <p class="m-0">Biscuit tart tart powder muffin jelly beans. Jelly apple pie chocolate cake. Cotton candy chocolate cake pie toffee dessert chocolate bar. Apple pie cake sweet danish danish sweet roll biscuit apple pie dragée. Brownie tiramisu jelly beans candy donut jelly-o marzipan. Pudding liquorice cupcake tart lollipop macaroon soufflé chocolate cake caramels. Caramels marshmallow candy canes cake caramels danish cake chocolate cake.</p>
                  </div>
                  <img class="rounded-circle align-self-start" src="assets/img/portrait/small/avatar-s-11.png" alt="avatar" width="70" height="70">
                </div>
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Middle Aligned Media</h5>
                    <p class="m-0">Pastry sugar plum jelly beans carrot cake halvah lemon drops muffin apple pie. Sesame snaps fruitcake carrot cake soufflé wafer. Marshmallow tootsie roll bear claw pie marshmallow jujubes cheesecake chocolate soufflé. Cookie chocolate candy canes cake tiramisu cotton candy marzipan caramels pie. Dragée gummies chocolate bar powder chocolate candy tootsie roll. Sugar plum pastry soufflé gingerbread muffin.</p>
                  </div>
                  <img class="rounded-circle align-self-center" src="assets/img/portrait/small/avatar-s-9.png" alt="avatar" width="70" height="70">
                </div>
                <div class="media">
                  <div class="media-body text-right mr-3">
                    <h5 class="mb-1">Bottom Aligned Media</h5>
                    <p class="m-0">Marshmallow liquorice wafer lollipop apple pie jelly-o jelly soufflé. Cheesecake cupcake gummies brownie pie caramels marshmallow cheesecake. Bonbon candy cupcake liquorice. Sweet roll bear claw pudding lemon drops liquorice liquorice macaroon dragée. Dragée pudding sweet roll soufflé cupcake. Powder gummies pastry bear claw tootsie roll jelly beans candy canes. Sugar plum chocolate cake toffee.</p>
                  </div>
                  <img class="rounded-circle align-self-end" src="assets/img/portrait/small/avatar-s-24.png" alt="avatar" width="70" height="70">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Right Media vertical Aligned Ends-->
    </div>
  </section>
  <!-- Media Alignment ends -->
</div>
